import { type TiendanubeProductsResponse, useTintVTOAxiosService } from "@/services/axiosService"
import { useAlert } from "providers/AlertProvider.tsx"
import { useTranslation } from "react-i18next"
import { useQuery } from "@tanstack/react-query"

export const TIENDANUBE_PRODUCTS_QUERY_KEY = "tiendanube-products"

interface TiendanubeProductsQueryParams {
  username: string
  page?: number
  productName?: string
  perPage?: number
}

export const useTiendanubeProductsQuery = ({
  username,
  page,
  productName,
  perPage,
}: TiendanubeProductsQueryParams) => {
  const { showAlert } = useAlert()
  const { t } = useTranslation()
  const service = useTintVTOAxiosService()

  return useQuery<TiendanubeProductsResponse>({
    queryKey: [TIENDANUBE_PRODUCTS_QUERY_KEY, username, page, productName, perPage],
    queryFn: async () => {
      try {
        return await service.getTiendanubeProducts(username, page, productName, perPage)
      } catch (error) {
        showAlert({ error: true, text: t("tiendanubeProducts.fetchError") })
        throw error
      }
    },
    staleTime: 600000, // 10 minutes
  })
}
